import { render, staticRenderFns } from "./DataScope.vue?vue&type=template&id=7a309378&scoped=true"
import script from "./DataScope.vue?vue&type=script&lang=js"
export * from "./DataScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a309378",
  null
  
)

export default component.exports